module.exports = __webpack_public_path__ + "media/images/stripe/light-on-light@2x-5eda8b00779936b8fa41307e9b6b2df7.png";